import { configManagerCloudServicesApi as api } from '../configManagerCloudServicesApi';
import { withMutationNotifications } from 'app/shared/api/rtk-mutation-notifications';
import {
  AcceptInvitationApiArg,
  AcceptInvitationApiResponse,
  CreateInvitationApiArg,
  CreateInvitationApiResponse,
  DeclineInvitationApiArg,
  DeclineInvitationApiResponse,
  ListInvitationsApiArg,
  ListInvitationsApiResponse,
  ResendInvitationApiArg,
  ResendInvitationApiResponse,
  RevokeInvitationApiArg,
  RevokeInvitationApiResponse,
} from './types';

const BASE = '/config-manager-cloud-services/api/v1';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    createInvitation: build.mutation<CreateInvitationApiResponse, CreateInvitationApiArg>({
      query: queryArg => ({
        url: `${BASE}/accounts/${queryArg.accountId}/invitations`,
        method: 'POST',
        body: queryArg.invitation,
      }),
      invalidatesTags: ['INVITATION_LIST'],
    }),
    listInvitations: build.query<ListInvitationsApiResponse, ListInvitationsApiArg>({
      query: queryArg => ({ url: `${BASE}/accounts/${queryArg.accountId}/invitations` }),
      providesTags: ['INVITATION_LIST'],
    }),
    acceptInvitation: build.mutation<AcceptInvitationApiResponse, AcceptInvitationApiArg>({
      query: queryArg => ({ url: `${BASE}/invitations/${queryArg.token}/accept`, method: 'POST' }),
      invalidatesTags: ['USER_PROFILE', 'ACCOUNT_PROFILE', 'MEMBER_LIST', 'INVITATION_LIST'],
    }),
    declineInvitation: build.mutation<DeclineInvitationApiResponse, DeclineInvitationApiArg>({
      query: queryArg => ({ url: `${BASE}/invitations/${queryArg.token}/decline`, method: 'POST' }),
      invalidatesTags: ['INVITATION_LIST'],
    }),
    revokeInvitation: build.mutation<RevokeInvitationApiResponse, RevokeInvitationApiArg>({
      query: queryArg => ({
        url: `${BASE}/accounts/${queryArg.accountId}/invitations/${queryArg.invitationId}/revoke`,
        method: 'POST',
      }),
      invalidatesTags: ['INVITATION_LIST'],
      onQueryStarted: withMutationNotifications({
        success: () => 'Invitation revoked.',
        error: () => 'Could not revoke the invitation.',
      }),
    }),
    resendInvitation: build.mutation<ResendInvitationApiResponse, ResendInvitationApiArg>({
      query: queryArg => ({
        url: `${BASE}/accounts/${queryArg.accountId}/invitations/${queryArg.invitationId}/resend`,
        method: 'POST',
      }),
      invalidatesTags: ['INVITATION_LIST'],
      onQueryStarted: withMutationNotifications({
        success: () => 'Invitation resent.',
        error: () => 'Could not resend the invitation.',
      }),
    }),
  }),
  overrideExisting: false,
});

export { injectedRtkApi as invitationsApi };

export const {
  useCreateInvitationMutation,
  useListInvitationsQuery,
  useAcceptInvitationMutation,
  useDeclineInvitationMutation,
  useRevokeInvitationMutation,
  useResendInvitationMutation,
} = injectedRtkApi;
